module.exports = __webpack_public_path__ + "fonts/VetoSansCond-LightItalic.2b864ddd.eot";